<div
  [class.sticky-action-bar]="stickyHeader && isDesktop"
  [class.action-bar-tmNotes]="!stickyHeader && isDesktop"
  *ngIf="isDesktop"
>
  <ion-grid [fixed]="true">
    <ion-row
      class="breadcrumbs-container-tmNotes"
      *ngIf="!stickyHeader && isDesktop"
    >
      <ion-col>
        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
      </ion-col>
    </ion-row>
    <ion-row class="ion-align-items-center">
      <div>
        <ion-col size="8" class="ion-no-padding">
          <h2 data-cy="title-notifications" class="section-title" translate>
            {{ 'i18n.notifications.notifications' }}
          </h2>
        </ion-col>
      </div>
      <div *ngIf="stickyHeader" class="sticky-header-buttons">
        <ion-col size="auto" class="ion-no-padding">
          <ion-button
            *ngIf="activeTab === 'alerts'"
            data-cy="btn-sticky-desktop-open-filters"
            fill="clear"
            [ngClass]="
              hasFilters ? 'usf-fill-green-button' : 'usf-outline-green-button'
            "
            (click)="filter()"
          >
            <ion-icon slot="start" name="filter"></ion-icon>
            <ion-label translate>{{ 'i18n.notifications.filter' }}</ion-label>
          </ion-button>
        </ion-col>
        <ion-col size="auto">
          <ion-button
            data-cy="btn-sticky-desktop-mark-all-as-read"
            fill="clear"
            class="usf-outline-green-button mark-all-read-button"
            [disabled]="
              (activeTab === 'alerts' && allRead) ||
              (activeTab === 'tmnotes' && allReadTmNotes)
            "
            (click)="markAllNotificationsAsRead()"
          >
            <ion-label translate>{{
              'i18n.notifications.markAllAsRead'
            }}</ion-label>
          </ion-button>
        </ion-col>
      </div>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button
          fill="blank"
          class="swiper-buttons"
          [ngClass]="activeTab === 'alerts' ? 'swiper-buttons-active' : ''"
          (click)="triggerSwitchTab('tmnotes')"
          translate
          >{{ 'i18n.notifications.alerts' }}
          <ion-badge
            mode="ios"
            class="count-badge"
            *ngIf="unreadAlertCount > 0"
          >
            {{ unreadAlertCount }}
          </ion-badge>
        </ion-button>
        <ion-button
          fill="blank"
          class="swiper-buttons"
          [ngClass]="activeTab === 'tmnotes' ? 'swiper-buttons-active' : ''"
          (click)="triggerSwitchTab('alerts')"
          translate
          >{{ 'i18n.notifications.tmnotes' }}
          <ion-badge mode="ios" class="count-badge" *ngIf="unreadNoteCount > 0">
            {{ unreadNoteCount }}
          </ion-badge>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
<div class="sticky-action-bar" *ngIf="!isDesktop">
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col>
        <div class="swiper-buttons-container" #tabContainer>
          <ion-button
            fill="blank"
            class="swiper-buttons"
            [ngClass]="activeTab === 'alerts' ? 'swiper-buttons-active' : ''"
            (click)="triggerSwitchTab('tmnotes')"
            translate
            >{{ 'i18n.notifications.alerts' }}
            <ion-badge
              mode="ios"
              class="count-badge"
              *ngIf="unreadAlertCount > 0"
            >
              {{ unreadAlertCount }}
            </ion-badge>
          </ion-button>
          <ion-button
            fill="blank"
            class="swiper-buttons"
            [ngClass]="activeTab === 'tmnotes' ? 'swiper-buttons-active' : ''"
            (click)="triggerSwitchTab('alerts')"
            translate
            >{{ 'i18n.notifications.tmnotes' }}
            <ion-badge
              mode="ios"
              class="count-badge"
              *ngIf="unreadNoteCount > 0"
            >
              {{ unreadNoteCount }}
            </ion-badge>
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
